// extracted by mini-css-extract-plugin
module.exports = {"container":"ZoomImage-module--container--2jLC1","modal":"ZoomImage-module--modal--2OeJy","active":"ZoomImage-module--active--1YH4F","img":"ZoomImage-module--img--2B4M_"};